<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    viewBox="0 0 24 24"
  >
    <g id="icon_list_saving" transform="translate(-627 -469)">
      <path
        id="패스_4050"
        data-name="패스 4050"
        fill-opacity="0"
        d="M0,0H24V24H0Z"
        transform="translate(627 469)"
      />
      <g
        id="그룹_8631"
        data-name="그룹 8631"
        transform="translate(143.175 -43.733)"
      >
        <path
          id="savings_FILL1_wght400_GRAD0_opsz48"
          fill="#ffc304"
          d="M6.7,24.533q-.811-2.675-1.324-4.593T4.554,16.6q-.311-1.418-.432-2.472A17.691,17.691,0,0,1,4,12.105,5.735,5.735,0,0,1,5.729,7.891,5.735,5.735,0,0,1,9.944,6.161h5.4A5.494,5.494,0,0,1,17.2,4.594,5.2,5.2,0,0,1,19.67,4a1.614,1.614,0,0,1,1.621,1.621,1.332,1.332,0,0,1-.041.324,2.309,2.309,0,0,1-.095.3q-.108.3-.2.594a4.293,4.293,0,0,0-.149.648l2.459,2.459h2.351v7.538l-3.053,1-1.81,6.052H14.807V22.372H12.646v2.161Z"
          transform="translate(481.018 510.467)"
        />
        <path
          id="savings_FILL1_wght400_GRAD0_opsz48-2"
          data-name="savings_FILL1_wght400_GRAD0_opsz48"
          fill="#087ef7"
          d="M19.13,13.726a1.061,1.061,0,1,0-.77-.311A1.046,1.046,0,0,0,19.13,13.726Zm-8.646-2.7h5.4V9.4h-5.4Z"
          transform="translate(480.477 510.467)"
        />
      </g>
    </g>
  </svg>
</template>
<script>
export default {
  props: {
    width: {
      type: Number,
      default: 24,
    },
    height: {
      type: Number,
      default: 24,
    },
  },
};
</script>
